





































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Question } from '@/views/Form/Conversation.vue'

@Component
export default class FormPanel extends Vue {
    @Prop() question!: Question|null
    answer: any = null
    answerValidationError: string = null

    mounted(): void {
        this.answer = this.defaultAnswer
    }

    get defaultAnswer(): any {
        if (this.question.defaultAnswer) {
            return this.question.defaultAnswer
        }

        switch (this.question.input) {
            case 'multi-choice':
                return []

            default:
                return null
        }
    }

    get inputComponent(): string {
        switch (this.question.input) {
            case 'button':
                return 'kv-button'

            case 'choice':
                return 'input-choice'

            case 'multi-choice':
                return 'input-multi-choice'

            case 'textarea':
                return 'input-textarea'

            case 'money':
                return 'input-money'

            case 'text':
            default:
                return 'input-text'
        }
    }

    get inputPlaceholder(): string {
        if (this.question.choices) {
            return 'Type of kies een optie...'
        } else {
            return 'Hier komt het antwoord...'
        }
    }

    get inputRules(): string {
        let rules = 'required'

        if (this.question.inputAttrs && this.question.inputAttrs.rules) {
            rules += '|' + this.question.inputAttrs.rules
        }

        return rules
    }

    submitInput(valid): void {
        if (!valid) {
            return
        }

        this.submit(this.answer)
    }

    async submit(answer): Promise<void> {
        const valid = await this.validate(answer)
        if (!valid) {
             return
        }

        this.$emit('input', answer)
    }

    async validate(answer): Promise<boolean> {
        this.answerValidationError = null

        if (this.question.onValidate) {
            const result = await this.question.onValidate(answer)
            if (result !== true) {
                this.answerValidationError = result
                return false
            }
        }

        return true
    }
}
